import * as next from '../../../types/next'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.PdfGeneratorBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.PDF_SUMMARY_CONTROL) {
    throw new Error('Expected a valid PDF Summary control')
  }

  return {
    type: next.BLOCK_TYPE.PDF_GENERATOR,
    required: false, // can never be required
    settings: {
      ...upCommonSettings(uischema),
      linkText: uischema.options?.linkText,
      template: {
        id: uischema.options?.templateId
      }
    }
  }
}
